const mapLineItemsToTransactionInfoItems = (lineItems)=>lineItems.map((lineItem)=>({
            name: lineItem.name,
            price: `${(lineItem.price.unit.gross / 100).toFixed(2)}`
        })
    )
;

export { mapLineItemsToTransactionInfoItems };
//# sourceMappingURL=transaction-info-line-items.js.map
